const cleanupMap = new Map();

function makeDraggable(modalEl) {
  const dialog = modalEl && modalEl.querySelector('.modal-dialog');
  const header = modalEl && modalEl.querySelector('.modal-header');

  if (!dialog || !header) return;

  header.style.cursor = 'move';

  let startX = 0;
  let startY = 0;
  let dragging = false;

  const onMouseDown = (event) => {
    if (event.button !== 0) return;

    const blockedSelector = '.close, .btn, button, [data-dismiss], [data-bs-dismiss], .modal-title-actions, [draggable="false"], .no-drag';
    if (event.target.closest(blockedSelector)) {
      return;
    }

    dragging = true;
    const rect = dialog.getBoundingClientRect();
    startX = event.clientX - rect.left;
    startY = event.clientY - rect.top;

    dialog.style.position = 'absolute';
    dialog.style.margin = '0';

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (event) => {
    if (!dragging) return;
    dialog.style.left = `${event.clientX - startX}px`;
    dialog.style.top = `${event.clientY - startY}px`;
  };

  const onMouseUp = () => {
    dragging = false;
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  header.addEventListener('mousedown', onMouseDown);

  cleanupMap.set(modalEl, () => {
    header.removeEventListener('mousedown', onMouseDown);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    dialog.style.position = '';
    dialog.style.margin = '';
    dialog.style.left = '';
    dialog.style.top = '';
  });
}

function cleanup(modalEl) {
  const fn = cleanupMap.get(modalEl);
  if (fn) {
    fn();
    cleanupMap.delete(modalEl);
  }
}

const DraggableModalPlugin = {
  install(Vue) {
    Vue.mixin({
      mounted() {
        if (this.$root !== this) return;
        if (this.__draggableModalPlugin__) return;

        this.__draggableModalPlugin__ = true;

        this.$root.$on('bv::modal::shown', (_bvEvent, modalId) => {
          const modalEl = document.getElementById(modalId);
          if (!modalEl) return;
          cleanup(modalEl);
          makeDraggable(modalEl);
        });

        this.$root.$on('bv::modal::hidden', (_bvEvent, modalId) => {
          const modalEl = document.getElementById(modalId);
          if (!modalEl) return;
          cleanup(modalEl);
        });
      },
    });
  },
};

export default DraggableModalPlugin;

